import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";
import React from "react";

const useStyles = createStyles({
  wrapper: {
    border: `1px solid ${tokens.color.semantic.border.faint}`,
    borderRadius: tokens.radius.md,
    overflow: "hidden",
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    "& a": {
      color: tokens.color.semantic.text.link,
    },
  },
  footer: {
    display: "flex",
    borderTop: `1px solid ${tokens.color.semantic.border.faint}`,
    backgroundColor: tokens.color.semantic.bg.surface,
  },
});

interface RpiTableContainerProps extends React.PropsWithChildren {
  "aria-label"?: string;
  "data-testid"?: string;
  footer?: React.ReactNode;
}

export function RpiTableContainer({ children, footer, ...rest }: RpiTableContainerProps) {
  const { classes } = useStyles();
  return (
    <div className={classes.wrapper} {...rest}>
      {children}
      {footer && <div className={classes.footer}>{footer}</div>}
    </div>
  );
}
